export type Glyph = string[];

export const GLYPH_WIDTH_IN_PIXELS = 8;
export const GLYPH_HEIGHT_IN_PIXELS = 9;
const glyphs: Record<string, Glyph> = {
  'unknown': [
    '........',
    '........',
    '.@@@@@@.',
    '.@@@@@@.',
    '.@@@@@@.',
    '.@@@@@@.',
    '.@@@@@@.',
    '........',
    '........',
  ],
  ' ': [
    '........',
    '........',
    '........',
    '........',
    '........',
    '........',
    '........',
    '........',
    '........',
  ],
  'a': [
    '........',
    '........',
    '........',
    '..@@@@..',
    '.....@@.',
    '..@@@@@.',
    '.@@..@@.',
    '..@@@@@.',
    '........',
  ],
  'A': [
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '.@@@@@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '........',
  ],
  'b': [
    '........',
    '.@@.....',
    '.@@.....',
    '.@@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@@@@..',
    '........',
  ],
  'B': [
    '........',
    '.@@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '.@@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '.@@@@@..',
    '........',
  ],
  'c': [
    '........',
    '........',
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.@@.....',
    '.@@..@@.',
    '..@@@@..',
    '........',
  ],
  'C': [
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.@@.....',
    '.@@.....',
    '.@@.....',
    '.@@..@@.',
    '..@@@@..',
    '........',
  ],
  'd': [
    '........',
    '.....@@.',
    '.....@@.',
    '..@@@@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@@.',
    '........',
  ],
  'D': [
    '........',
    '.@@@@...',
    '.@@.@@..',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@.@@..',
    '.@@@@...',
    '........',
  ],
  'e': [
    '........',
    '........',
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.@@@@@@.',
    '.@@.....',
    '..@@@@..',
    '........',
  ],
  'E': [
    '........',
    '.@@@@@@.',
    '.@@.....',
    '.@@.....',
    '.@@@@@..',
    '.@@.....',
    '.@@.....',
    '.@@@@@@.',
    '........',
  ],
  'f': [
    '........',
    '...@@@..',
    '..@@....',
    '..@@....',
    '.@@@@@..',
    '..@@....',
    '..@@....',
    '..@@....',
    '........',
  ],
  'F': [
    '........',
    '.@@@@@@.',
    '.@@.....',
    '.@@.....',
    '.@@@@@..',
    '.@@.....',
    '.@@.....',
    '.@@.....',
    '........',
  ],
  'g': [
    '........',
    '........',
    '........',
    '..@@@@@.',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@@.',
    '.....@@.',
    '..@@@@..',
  ],
  'G': [
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.@@.....',
    '.@@.@@@.',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@..',
    '........',
  ],
  'h': [
    '........',
    '.@@.....',
    '.@@.....',
    '.@@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '........',
  ],
  'H': [
    '........',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@@@@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '........',
  ],
  'i': [
    '........',
    '...@@...',
    '........',
    '..@@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '..@@@@..',
    '........',
  ],
  'I': [
    '........',
    '.@@@@@@.',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '.@@@@@@.',
    '........',
  ],
  'j': [
    '........',
    '...@@...',
    '........',
    '..@@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '.@@@....',
  ],
  'J': [
    '........',
    '..@@@@@.',
    '....@@..',
    '....@@..',
    '....@@..',
    '....@@..',
    '.@@.@@..',
    '..@@@...',
    '........',
  ],
  'k': [
    '........',
    '.@@.....',
    '.@@.....',
    '.@@..@@.',
    '.@@.@@..',
    '.@@@@...',
    '.@@.@@..',
    '.@@..@@.',
    '........',
  ],
  'K': [
    '........',
    '.@@..@@.',
    '.@@.@@..',
    '.@@@@...',
    '.@@@....',
    '.@@@@...',
    '.@@.@@..',
    '.@@..@@.',
    '........',
  ],
  'l': [
    '........',
    '..@@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '..@@@@..',
    '........',
  ],
  'L': [
    '........',
    '.@@.....',
    '.@@.....',
    '.@@.....',
    '.@@.....',
    '.@@.....',
    '.@@.....',
    '.@@@@@@.',
    '........',
  ],
  'm': [
    '........',
    '........',
    '........',
    '..@@.@@.',
    '.@@@@@@.',
    '.@@.@.@.',
    '.@@.@.@.',
    '.@@...@.',
    '........',
  ],
  'M': [
    '........',
    '.@@...@.',
    '.@@@.@@.',
    '.@@@@@@.',
    '.@@.@.@.',
    '.@@.@.@.',
    '.@@...@.',
    '.@@...@.',
    '........',
  ],
  'n': [
    '........',
    '........',
    '........',
    '.@@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '........',
  ],
  'N': [
    '........',
    '.@@..@@.',
    '.@@..@@.',
    '.@@@.@@.',
    '.@@@@@@.',
    '.@@.@@@.',
    '.@@..@@.',
    '.@@..@@.',
    '........',
  ],
  'o': [
    '........',
    '........',
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@..',
    '........',
  ],
  'O': [
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@..',
    '........',
  ],
  'p': [
    '........',
    '........',
    '........',
    '.@@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '.@@@@@..',
    '.@@.....',
    '.@@.....',
  ],
  'P': [
    '........',
    '.@@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '.@@@@@..',
    '.@@.....',
    '.@@.....',
    '.@@.....',
    '........',
  ],
  'q': [
    '........',
    '........',
    '........',
    '..@@@@@.',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@@.',
    '.....@@.',
    '.....@@.',
  ],
  'Q': [
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@.@.@.',
    '.@@.@@..',
    '..@@.@@.',
    '........',
  ],
  'r': [
    '........',
    '........',
    '........',
    '.@@.@@..',
    '.@@@.@@.',
    '.@@.....',
    '.@@.....',
    '.@@.....',
    '........',
  ],
  'R': [
    '........',
    '.@@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '.@@@@@..',
    '.@@.@@..',
    '.@@..@@.',
    '.@@..@@.',
    '........',
  ],
  's': [
    '........',
    '........',
    '........',
    '..@@@@@.',
    '.@@.....',
    '..@@@@..',
    '.....@@.',
    '.@@@@@..',
    '........',
  ],
  'S': [
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.@@.....',
    '..@@@@..',
    '.....@@.',
    '.@@..@@.',
    '..@@@@..',
    '........',
  ],
  't': [
    '........',
    '..@@....',
    '..@@....',
    '.@@@@@..',
    '..@@....',
    '..@@....',
    '..@@....',
    '...@@@..',
    '........',
  ],
  'T': [
    '........',
    '.@@@@@@.',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '........',
  ],
  'u': [
    '........',
    '........',
    '........',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@@.',
    '........',
  ],
  'U': [
    '........',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@..',
    '........',
  ],
  'v': [
    '........',
    '........',
    '........',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@..',
    '...@@...',
    '........',
  ],
  'V': [
    '........',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@..',
    '...@@...',
    '........',
  ],
  'w': [
    '........',
    '........',
    '........',
    '.@@...@.',
    '.@@.@.@.',
    '.@@.@.@.',
    '.@@@@@@.',
    '..@@.@@.',
    '........',
  ],
  'W': [
    '........',
    '.@@...@.',
    '.@@...@.',
    '.@@.@.@.',
    '.@@.@.@.',
    '.@@@@@@.',
    '.@@@.@@.',
    '.@@...@.',
    '........',
  ],
  'x': [
    '........',
    '........',
    '........',
    '.@@..@@.',
    '..@@@@..',
    '...@@...',
    '..@@@@..',
    '.@@..@@.',
    '........',
  ],
  'X': [
    '........',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@..',
    '...@@...',
    '..@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '........',
  ],
  'y': [
    '........',
    '........',
    '........',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@@.',
    '.....@@.',
    '..@@@@..',
  ],
  'Y': [
    '........',
    '.@@..@@.',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@..',
    '...@@...',
    '...@@...',
    '...@@...',
    '........',
  ],
  'z': [
    '........',
    '........',
    '........',
    '.@@@@@@.',
    '....@@..',
    '...@@...',
    '..@@....',
    '.@@@@@@.',
    '........',
  ],
  'Z': [
    '........',
    '.@@@@@@.',
    '.....@@.',
    '....@@..',
    '...@@...',
    '..@@....',
    '.@@.....',
    '.@@@@@@.',
    '........',
  ],
  '0': [
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.@@.@@@.',
    '.@@@@@@.',
    '.@@@.@@.',
    '.@@..@@.',
    '..@@@@..',
    '........',
  ],
  '1': [
    '........',
    '...@@...',
    '..@@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '.@@@@@@.',
    '........',
  ],
  '2': [
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.....@@.',
    '....@@..',
    '...@@...',
    '..@@....',
    '.@@@@@@.',
    '........',
  ],
  '3': [
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.....@@.',
    '...@@@..',
    '.....@@.',
    '.@@..@@.',
    '..@@@@..',
    '........',
  ],
  '4': [
    '........',
    '....@@..',
    '...@@@..',
    '..@@@@..',
    '.@@.@@..',
    '.@@@@@@.',
    '....@@..',
    '....@@..',
    '........',
  ],
  '5': [
    '........',
    '.@@@@@@.',
    '.@@.....',
    '.@@@@@..',
    '.....@@.',
    '.....@@.',
    '.@@..@@.',
    '..@@@@..',
    '........',
  ],
  '6': [
    '........',
    '...@@@..',
    '..@@....',
    '.@@.....',
    '.@@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@..',
    '........',
  ],
  '7': [
    '........',
    '.@@@@@@.',
    '.....@@.',
    '....@@..',
    '...@@...',
    '..@@....',
    '..@@....',
    '..@@....',
    '........',
  ],
  '8': [
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@..',
    '........',
  ],
  '9': [
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.@@..@@.',
    '..@@@@@.',
    '.....@@.',
    '....@@..',
    '..@@@...',
    '........',
  ],
  '$': [
    '........',
    '....@@..',
    '..@@@@@.',
    '.@@.@...',
    '..@@@@@.',
    '....@.@.',
    '.@@@@@@.',
    '...@@...',
    '........',
  ],
  '!': [
    '........',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '........',
    '...@@...',
    '........',
  ],
  '°': [
    '........',
    '.@@.@@..',
    '.@@.@@..',
    '.@@.@@..',
    '........',
    '........',
    '........',
    '........',
    '........',
  ],
  '\'': [
    '........',
    '....@@..',
    '...@@...',
    '..@@....',
    '........',
    '........',
    '........',
    '........',
    '........',
  ],
  '(': [
    '........',
    '....@@..',
    '...@@...',
    '..@@....',
    '..@@....',
    '..@@....',
    '...@@...',
    '....@@..',
    '........',
  ],
  ')': [
    '........',
    '..@@....',
    '...@@...',
    '....@@..',
    '....@@..',
    '....@@..',
    '...@@...',
    '..@@....',
    '........',
  ],
  ',': [
    '........',
    '........',
    '........',
    '........',
    '........',
    '........',
    '...@@...',
    '...@@...',
    '..@@....',
  ],
  '_': [
    '........',
    '........',
    '........',
    '........',
    '........',
    '........',
    '........',
    '........',
    '@@@@@@@@',
  ],
  '-': [
    '........',
    '........',
    '........',
    '........',
    '.@@@@@@.',
    '........',
    '........',
    '........',
    '........',
  ],
  '.': [
    '........',
    '........',
    '........',
    '........',
    '........',
    '........',
    '...@@...',
    '...@@...',
    '........',
  ],
  '/': [
    '........',
    '........',
    '.....@@.',
    '....@@..',
    '...@@...',
    '..@@....',
    '.@@.....',
    '........',
    '........',
  ],
  ':': [
    '........',
    '........',
    '........',
    '...@@...',
    '...@@...',
    '........',
    '...@@...',
    '...@@...',
    '........',
  ],
  ';': [
    '........',
    '........',
    '........',
    '...@@...',
    '...@@...',
    '........',
    '...@@...',
    '...@@...',
    '..@@....',
  ],
  '?': [
    '........',
    '..@@@@..',
    '.@@..@@.',
    '....@@..',
    '...@@...',
    '...@@...',
    '........',
    '...@@...',
    '........',
  ],
  '+': [
    '........',
    '........',
    '...@@...',
    '...@@...',
    '.@@@@@@.',
    '...@@...',
    '...@@...',
    '........',
    '........',
  ],
  '<': [
    '........',
    '....@@..',
    '...@@...',
    '..@@....',
    '.@@.....',
    '..@@....',
    '...@@...',
    '....@@..',
    '........',
  ],
  '=': [
    '........',
    '........',
    '........',
    '.@@@@@@.',
    '........',
    '.@@@@@@.',
    '........',
    '........',
    '........',
  ],
  '>': [
    '........',
    '..@@....',
    '...@@...',
    '....@@..',
    '.....@@.',
    '....@@..',
    '...@@...',
    '..@@....',
    '........',
  ],
  '#': [
    '........',
    '..@@.@@.',
    '..@@.@@.',
    '.@@@@@@.',
    '..@@.@@.',
    '.@@@@@@.',
    '..@@.@@.',
    '..@@.@@.',
    '........',
  ],
  '%': [
    '........',
    '.@@.....',
    '.@@..@@.',
    '....@@..',
    '...@@...',
    '..@@....',
    '.@@..@@.',
    '.....@@.',
    '........',
  ],
  '&': [
    '........',
    '..@@@...',
    '.@@.@@..',
    '.@@.@@..',
    '..@@@...',
    '.@@.@@..',
    '.@@..@@.',
    '..@@@.@.',
    '........',
  ],
  '*': [
    '........',
    '........',
    '...@@...',
    '.@@@@@@.',
    '..@@@@..',
    '.@@@@@@.',
    '...@@...',
    '........',
    '........',
  ],
  '@': [
    '........',
    '..@@@@..',
    '.@@..@@.',
    '.@@.@@@.',
    '.@@.@.@.',
    '.@@.@@@.',
    '.@@.....',
    '..@@@@..',
    '........',
  ],
  '[': [
    '........',
    '.@@@@@..',
    '.@@.....',
    '.@@.....',
    '.@@.....',
    '.@@.....',
    '.@@.....',
    '.@@@@@..',
    '........',
  ],
  '\\': [
    '........',
    '........',
    '.@@.....',
    '..@@....',
    '...@@...',
    '....@@..',
    '.....@@.',
    '........',
    '........',
  ],
  ']': [
    '........',
    '..@@@@@.',
    '.....@@.',
    '.....@@.',
    '.....@@.',
    '.....@@.',
    '.....@@.',
    '..@@@@@.',
    '........',
  ],
  '{': [
    '........',
    '....@@..',
    '...@@...',
    '...@@...',
    '.@@@....',
    '...@@...',
    '...@@...',
    '....@@..',
    '........',
  ],
  '|': [
    '........',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '...@@...',
    '........',
  ],
  '}': [
    '........',
    '..@@....',
    '...@@...',
    '...@@...',
    '....@@@.',
    '...@@...',
    '...@@...',
    '..@@....',
    '........',
  ],
  '~': [
    '........',
    '..@@....',
    '.@@.@.@.',
    '.@...@@.',
    '........',
    '........',
    '........',
    '........',
    '........',
  ],
  '"': [
    '........',
    '.@@..@@.',
    '.@@..@@.',
    '........',
    '........',
    '........',
    '........',
    '........',
    '........',
  ],
  '^': [
    '........',
    '...@@...',
    '..@@@@..',
    '.@@..@@.',
    '.@....@.',
    '........',
    '........',
    '........',
    '........',
  ],
};

export function getGlyph(c: string): Glyph {
  let g = glyphs[c];
  if (g === undefined) {
    g = glyphs['unknown'];
  }
  return g;
}
